/* ==========================================================================
   Taana — handle-grid.js
   Renders product cards for a list of handles stored in the browser
   (wishlist, recently viewed) via the Section Rendering API.
   ========================================================================== */
(() => {
  const Theme = (window.Theme = window.Theme || {});
  const readList = (key) => {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  };

  /* ---------- Wishlist / recently viewed grids ---------- */
  class HandleGrid extends HTMLElement {
    async connectedCallback() {
      const source = this.dataset.source;
      let handles = [];
      if (source === 'wishlist') handles = readList('taana:wishlist');
      if (source === 'recent') {
        try { handles = JSON.parse(localStorage.getItem('taana:recently-viewed')) || []; } catch (e) { handles = []; }
        const exclude = this.dataset.exclude;
        handles = handles.filter((h) => h !== exclude);
      }
      handles = handles.slice(0, Number(this.dataset.limit) || 12);
      const list = this.querySelector('[data-handle-list]');
      const empty = this.querySelector('[data-handle-empty]');
      if (!list) return;
      if (!handles.length) {
        if (empty) empty.hidden = false;
        return;
      }
      const cards = await Promise.all(handles.map((h) => this.fetchCard(h)));
      const items = cards.filter(Boolean);
      if (!items.length) {
        if (empty) empty.hidden = false;
        return;
      }
      list.replaceChildren(...items);
      this.classList.add('is-loaded');
      const host = this.closest('[data-handle-section]');
      if (host) host.hidden = false;
      document.dispatchEvent(new CustomEvent('taana:layout-change'));
      if (source === 'wishlist') {
        this.onChange = (e) => {
          if (e.detail.added) return;
          const li = list.querySelector(`[data-handle="${CSS.escape(e.detail.handle)}"]`);
          li && li.remove();
          if (!list.children.length && empty) empty.hidden = false;
        };
        document.addEventListener('taana:wishlist:change', this.onChange);
      }
    }
    disconnectedCallback() {
      this.onChange && document.removeEventListener('taana:wishlist:change', this.onChange);
    }
    async fetchCard(handle) {
      try {
        const res = await fetch(`${Theme.routes.root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}?section_id=product-card-render`);
        if (!res.ok) return null;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const card = doc.querySelector('product-card');
        if (!card) return null;
        const li = document.createElement('li');
        li.dataset.handle = handle;
        li.className = this.dataset.itemClass || '';
        li.appendChild(document.importNode(card, true));
        return li;
      } catch (e) {
        return null;
      }
    }
  }
  if (!customElements.get('handle-grid')) customElements.define('handle-grid', HandleGrid);
})();
